import { render } from "./research-equipment-compare.vue?vue&type=template&id=ced85d40&ts=true"
import script from "./research-equipment-compare.vue?vue&type=script&lang=ts"
export * from "./research-equipment-compare.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__